import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as amplitude from '@amplitude/unified';

amplitude.initAll('1fd7722fa56c2e13aa3bf44b787797d7', {"analytics":{"autocapture":true},"sessionReplay":{"sampleRate":1}});

// Ignore noisy errors thrown by browser extensions (e.g. Adblock Plus's frame_ant.js
// calling .clone() on a Response whose body our app already consumed). These don't
// affect the app but trigger React's full-screen dev error overlay.
const isExtensionError = (msgOrErr) => {
  if (!msgOrErr) return false;
  const stack = typeof msgOrErr === "string" ? msgOrErr : (msgOrErr.stack || msgOrErr.message || "");
  return typeof stack === "string" && (
    stack.includes("chrome-extension://") ||
    stack.includes("moz-extension://") ||
    stack.includes("safari-extension://")
  );
};

window.addEventListener("error", (e) => {
  if (isExtensionError(e.error) || isExtensionError(e.filename)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

window.addEventListener("unhandledrejection", (e) => {
  if (isExtensionError(e.reason)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
